import TableCell from "@mui/material/TableCell";
import "./index.scss";
import { IconButton } from "@mui/material";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import { formatDate } from "../../../common-utilities/utils";
import { DATE_FORMATS } from "../../../common-utilities/utils/constants";
import { allRegions } from "../../../common-utilities/utils/region";

export const getHeaderConfig = (role) => {
  if (role === "READ_ONLY") {
  return [
      {
      label: "Store Name",
      id: "storeName",
      render: (data) =>
        `${data?.name ?? ""}-${data?.ownerName ?? ""}`,
    },
    { label: "Store Code (9 digit)", id: "name" },
    { label: "Store Code (5 digit)", id: "storeNumber" },
    { label: "Store Type", id: "storeType" },
    {
      label: "Store Opening Date",
      id: "storeOpeningDate",
      valueConversionLogic: (val) =>
        formatDate(val, DATE_FORMATS["DD-MM-YYYY"]),
    },
    { label: "City", id: "city" },
    { label: "State", id: "state" },
    { label: "Circle", id: "circle" },
    { label: "Address", id: "address" },
    { label: "Pincode", id: "pinCode" },
    { label: "Latitude", id: "latitude" },
    { label: "Longitude", id: "longitude" },
    {
      label: "Area Manager",
      id: "am",
      render: (data) => <div>{data?.am?.name}</div>,
    },
  ];
}

  const result = [
    {
      label: "Name",
      id: "name",
    },
    {
      label: "Store Number",
      id: "storeNumber",
    },
    {
      label: "Satellite Number",
      id: "satelliteNumber",
    },
    {
      label: "Sequence Number",
      id: "sequenceNumber",
    },
    {
      label: "Store Name",
      id: "ownerName",
    },
    {
      label: "Store Type",
      id: "storeType",
    },
    {
      label: "Store Opening Date",
      id: "storeOpeningDate",
      valueConversionLogic: (val) =>
        formatDate(val, DATE_FORMATS["DD-MM-YYYY"]),
    },
    {
      label: "Region",
      id: "region",
    },
    {
      label: "Tier-City",
      id: "tierCity",
    },
    {
      label: "Circle",
      id: "circle",
    },
    {
      label: "City",
      id: "city",
    },

    {
      label: "Format",
      id: "format",
    },
    {
      label: "Status",
      id: "status",
    },
    { label: "Split", id: "split" },
    {
      label: "Outlier",
      id: "typeOfDecor",
    },
    {
      label: "AM Name",
      id: "am",
      render: (data, onClick) => {
        return <div>{data?.am?.name}</div>;
      },
    },
    {
      label: "AM Email",
      id: "am",
      render: (data, onClick) => {
        return <div>{data?.am?.email}</div>;
      },
    },
    {
      label: "RM Name",
      id: "rm",
      render: (data, onClick) => {
        return <div>{data?.rm?.name}</div>;
      },
    },
    {
      label: "RM Email",
      id: "rm",
      render: (data) => {
        return <div>{data?.rm?.email}</div>;
      },
    },
    {
      label: "Price Cohort",
      id: "priceCohort",
    },
    {
      label: "Address ",
      id: "address",
    },

    {
      label: "State",
      id: "state",
    },
    {
      label: "Area",
      id: "area",
    },

    {
      label: "Country",
      id: "country",
    },
    {
      label: "Pincode",
      id: "pinCode",
    },
    {
      label: "Latitude ",
      id: "latitude",
    },
    {
      label: "Longitude",
      id: "longitude",
    },
    { label: "Rice Bowl Launch Phase", id: "riceBowlLaunchPhase" },
    {
      label: "HnC Activation",
      id: "hncActivation",
    },
    {
      label: "Cravers Activation",
      id: "craversActivation",
    },
    {
      label: "New Salad Activation",
      id: "newSaladActivation",
    },
    {
      label: "Coffee Activation",
      id: "coffeeActivation",
    },
    {
      label: "Bolt Activation",
      id: "boltActivation",
    },
    {
      label: "Breakfast Activation",
      id: "breakfastActivation",
    },
    {
      label: "Night Delivery Activation",
      id: "nightDeliveryActivation",
    },
    {
      label: "Store Display Name",
      id: "restaurantName",
    },
    {
      label: "Sub Format",
      id: "subFormat",
    },

    {
      label: "DC Name",
      id: "dcname",
      render: (data) => {
        return <div>{data?.dc?.name}</div>;
      },
    },
    {
      label: "DC Email",
      id: "dcemail",
      render: (data) => {
        return <div>{data?.dc?.email}</div>;
      },
    },
    {
      label: "Store Email",
      id: "email",
    },
    {
      label: "FZ Name",
      id: "fzName",
    },
    {
      label: "PAN",
      id: "pan",
    },
    {
      label: "GST",
      id: "gstn",
    },
    {
      label: "Operating Entity Name",
      id: "franchiseBusinessName",
    },
    {
      label: "Contact Number",
      id: "contactNumber",
    },

    {
      label: "LSM Status",
      id: "lsmStatus",
    },
    {
      label: "Coffee Status",
      id: "coffeeStatus",
    },

    {
      label: "Electricity Unit Rate",
      id: "electricityChargePerUnit",
    },
    {
      label: "Conversion Factor",
      id: "conversionFactor",
    },
    {
      label: "Count Of Screens",
      id: "countOfScreens",
    },
    {
      label: "Store Covers",
      id: "storeCovers",
    },
    {
      label: "DMB Type",
      id: "dmbType",
    },
    {
      label: "Screens Format",
      id: "screensFormat",
    },

    {
      label: "FS Team Member",
      id: "firstLevelEscalation",
      render: (data) => {
        return (
          <span key="firstLevelEscalation">
            {data?.firstLevelEscalation?.email}
          </span>
        );
      },
    },
  ];
  if (role === "admin") {
    result.push({
      label: "Actions",
      id: "action",
      render: (data, onClick) => {
        return (
          <div>
            <Stack
              direction="row"
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <IconButton
                sx={{ pt: 0.5, pb: 0.5 }}
                onClick={() => onClick("update store details", data)}
              >
                <EditIcon id="edit" color="primary" />
              </IconButton>
            </Stack>
          </div>
        );
      },
    });
  }
  return result;
};
export const REGIONS_LIST = [
  { label: "North", value: "north" },
  { label: "South", value: "south" },
  { label: "East", value: "east" },
  { label: "Central", value: "central" },
  { label: "West", value: "west" },
];
export const STORE_TYPE = [
  { label: "COCO BUILT", value: "COCO_BUILT" },
  { label: "COCO ACQUIRED", value: "COCO_ACQUIRED" },
  { label: "FOFO", value: "FOFO" },
];
export const STORE_STATUS_LIST = [
  { label: "Temp Closure", value: "Temp Closure" },
  { label: "Yet to Open", value: "Yet to Open" },
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Satellite Store", value: "Satellite Store" },
];
export const UserRoles = {
  areaManger: "Area Manager",
  regionalManger: "Regional Manger",
  opsManager: "Ops Manager",
};
export const DMB_TYPE = [
  { label: "Central (apps)", value: "Central (apps)" },
  { label: "Manual", value: "Manual" },
];
export const SCREEN_FORMAT = [
  { label: "Vertical", value: "Vertical" },
  { label: "Horizontal", value: "Horizontal" },
  { label: "Mixed", value: "Mixed" },
];
export const STORE_TYPE_MAP = {
  "COCO BUILT": "COCO_BUILT",
  "COCO ACQUIRED": "COCO_ACQUIRED",
  FOFO: "FOFO",
};

export const FORMAT_LIST = [
  { label: "High street", value: "High street" },
  { label: "Mall", value: "Mall" },
  { label: "Non Traditional", value: "Non Traditional" },
];
export const SUB_FORMAT_LIST = [
  { label: "Airport", value: "Airport" },
  { label: "Food Court", value: "Food Court" },
  { label: "Highway", value: "Highway" },
  { label: "High Street", value: "High Street" },
  { label: "Hospital", value: "Hospital" },
  { label: "Institute", value: "Institute" },
  { label: "Mall", value: "Mall" },
  { label: "Tech Park", value: "Tech Park" },
  { label: "Metro Station", value: "Metro Station" },
];

export const CIRCLE_LIST = [
  { label: "AP&TS", value: "AP&TS" },
  { label: "Bangalore", value: "Bangalore" },
  { label: "Bihar, Jharkhand & Orissa", value: "Bihar, Jharkhand & Orissa" },
  { label: "Delhi", value: "Delhi" },
  { label: "EDNGF", value: "EDNGF" },
  { label: "GG", value: "GG" },
  { label: "Gujarat, MP & CG", value: "Gujarat, MP & CG" },
  { label: "Mumbai", value: "Mumbai" },
  {
    label: "North Punjab, JK HP @ Jallandhar",
    value: "North Punjab, JK HP @ Jallandhar",
  },
  { label: "Raj & Har", value: "Raj & Har" },
  { label: "ROK", value: "ROK" },
  { label: "ROK and Goa", value: "ROK and Goa" },
  { label: "RoMH", value: "RoMH" },
  { label: "RoMH & Goa", value: "RoMH & Goa" },
  { label: "South punjab @  Chandigarh", value: "South punjab @  Chandigarh" },
  { label: "TBU", value: "TBU" },
  { label: "TN&K", value: "TN&K" },
  { label: "Up&UK", value: "Up&UK" },
  { label: "WB & NE", value: "WB & NE" },
  { label: "NCR", value: "NCR" },
  { label: "Punjab", value: "Punjab" },
  { label: "Sri lanka", value: "Sri lanka" },
];
export const SPLIT_LIST = [
  { label: "Non-split", value: "Non-split" },
  { label: "Split", value: "Split" },
];
export const CRAVERS_LAUNCH_PHASE_LIST = [
  { label: "Cravers not launched", value: "Cravers not launched" },
  { label: "Phase 1", value: "Phase 1" },
  { label: "Phase 2", value: "Phase 2" },
  { label: "Phase 3", value: "Phase 3" },
];
export const CAT_LIST = [
  { label: "Cat-1 / FY23", value: "Cat-1 / FY23" },
  { label: "Cat-2 / FY24", value: "Cat-2 / FY24" },
  { label: "Cat-3 / FY25", value: "Cat-3 / FY25" },
  { label: "Cat-4 / FY26", value: "Cat-4 / FY26" },
  { label: "Cat-5 / FY27", value: "Cat-5 / FY27" },
  { label: "LFL excl. airport", value: "LFL excl. airport" },
  { label: "Others", value: "Others" },
];

export const TIER_CITY_LIST = [
  { label: "Metro", value: "Metro" },
  { label: "Non-traditional", value: "Non-traditional" },
  { label: "Tier 1", value: "Tier 1" },
  { label: "Tier 2", value: "Tier 2" },
  { label: "Tier 3", value: "Tier 3" },
];
export const COFFEE_STATUS_LIST = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
export const BREAKFAST_LIST = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
];
export const ACTIVATION_STATUS = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
];
export const DISPLAY_BRAND = [
  { label: "Geeken", value: "Geeken" },
  { label: "VU", value: "VU" },
  { label: "LG", value: "LG" },
  { label: "Samsung", value: "Samsung" },
];
export const STORE_OPERATION_LIST = [
  { label: "Regular", value: "REGULAR" },
  { label: "Breakfast", value: "BREAKFAST" },
  { label: "Late night", value: "LATE_NIGHT" },
];
export const LFL_LIST = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

// Extract Indian states from region.js
export const INDIAN_STATES_LIST = Object.keys(allRegions.India || {})
  .sort()
  .map(state => ({ label: state, value: state }));
